import React, {useEffect} from 'react';
import {Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

import {ContentHierarchyIcon} from './ContentHierarchyIcon';

export const HierarchyNode = (props) => {

    const {droppable} = props.node;
    const indent = props.depth * 24;
    const nodeType = props.node.type;
    const color = nodeType === "root" ? props.node.color : "";

    const mainContainerStyle = {
        alignItems: 'center',
        display: 'grid',
        gridTemplateColumns: 'auto auto 1fr auto',
        height: '100%',
        paddingInlineEnd: '0.5rem',
    }

    const expandIconWrapperStyle = {
        alignItems: 'center',
        fontSize: '0',
        cursor: 'pointer',
        display: 'flex',
        height: '1.5rem',
        justifyContent: 'center',
        width: '1.5rem',
        transition: 'transform linear .1s',
        transform: props.isOpen ? 'rotate(90deg)' : 'rotate(0deg)'
    }

    const labelGridItemStyle = {paddingInlineStart: '0.5rem'}
    const highlightedTextStyle = {backgroundColor: '#ADD8E6'}

    const handleToggle = (e) => {
        e.stopPropagation();
        props.onToggle(props.node.id);
        if(props.isOpen){
            props.setCollapsedNodes([...props.collapsedNodes, props.node.id]);
        }
        else{
            const index = props.collapsedNodes.indexOf(props.node.id);
            if (index > -1) {
                props.collapsedNodes.splice(index, 1);
            }
            props.setCollapsedNodes([...props.collapsedNodes]);
        }
    };

    const handleSelect = (e) => {
        e.stopPropagation();
        props.onSelect(props.node);
    }

    useEffect(() => {
        props.updateNode(props.node);
    }, [props.parent, props.hasChild]);

    return (
      <Grid container sx={mainContainerStyle} style={{paddingInlineStart: indent}} onClick={handleToggle}>
          <Grid sx={expandIconWrapperStyle}>
              {droppable && (<ArrowRightIcon />)}
          </Grid>
          <Grid>
              <ContentHierarchyIcon nodeType={nodeType} color={color} />
          </Grid>
          <Grid sx={labelGridItemStyle} onClick={handleSelect}>
              <Typography variant='body2' sx={props.isSelected ? highlightedTextStyle : ''}>
                  {props.node.text}
              </Typography>
          </Grid>
      </Grid>
    );
};
